import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { LOGIN } from '../src/routes'

/**
 * Decodes the JWT payload and checks whether the token's `exp` claim is in the past.
 * No signature verification is performed here — that is the server's responsibility.
 * Returns true (expired) for any token that cannot be parsed.
 */
function isTokenExpired(token: string): boolean {
  try {
    const payload = token.split('.')[1]
    const decoded = JSON.parse(atob(payload))
    return decoded.exp * 1000 < Date.now()
  } catch {
    return true
  }
}

export default function AuthChecker({ children }) {
  const router = useRouter()

  useEffect(() => {
    if (router.pathname === LOGIN) return

    const token = localStorage.getItem('token')
    if (!token || isTokenExpired(token)) {
      // Token is missing or the Okta access_token has expired.
      // Clear stale session data and send the user back to the login page.
      localStorage.clear()
      window.location.href = '/'
    }
  }, [router])

  return children
}
